import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';

import {getMessage} from './../../utils/i18n';
import {getCallbackCache, closeBoConfirmation} from './../../actions/confirmation';

class Confirmation extends Component {

    static propTypes = {
        id: PropTypes.number,
        message: PropTypes.string,
        closeBoConfirmation: PropTypes.func.isRequired
    };

    getCallbackFn() {
        const callbackCache = getCallbackCache();
        if (callbackCache.id === this.props.id && typeof(callbackCache.func) === 'function') {
            return callbackCache.func;
        } else {
            return () => (undefined);
        }
    }

    onConfirm() {
        this.getCallbackFn()(true);
        this.props.closeBoConfirmation();
    };

    onCancel() {
        this.getCallbackFn()(false);
        this.props.closeBoConfirmation();
    };

    render() {
        return (
            <Modal backdrop="static" show={Boolean(this.props.id)} onHide={this.onCancel.bind(this)}>
                <Modal.Header closeButton/>
                <Modal.Body>
                    <p>{this.props.message || ''}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="foPrimaryButton" onClick={this.onConfirm.bind(this)}>{getMessage("modal.actions.confirm")}</button>
                    <button className="foNormalButton" onClick={this.onCancel.bind(this)}>{getMessage("modal.actions.cancel")}</button>
                </Modal.Footer>
            </Modal>
        );
    };

}

export default connect((state) => ({
        id: state.confirmation.id,
        message: state.confirmation.message
    }), {
        closeBoConfirmation: closeBoConfirmation
    }
)(Confirmation);


// WEBPACK FOOTER //
// ./src/app/containers/confirmation/index.js